import { useEffect } from 'react'
import { useToast } from '@/store/appStore'

export const useToastNew = () => {
  const { toastMessage, toastType, showToast, clearToast } = useToast()

  // Auto-clear toast after 5 seconds
  useEffect(() => {
    if (toastMessage) {
      const timer = setTimeout(() => {
        clearToast()
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [toastMessage, clearToast])

  return {
    toastMessage,
    toastType,
    showToast,
    clearToast,
  }
}
